import { useContext } from "react";

import { getErrorString } from "../../utils/get-errors";
import { RanaFormContext } from "../rana-form";

export const useFormFieldError = (field: string) => {
  const { errors } = useContext(RanaFormContext);
  const error = errors?.[field] ?? null;

  if (typeof error !== "string") return getErrorString(error);

  return error;
};
